import React from 'react';

import type { SkeletonShapeProps } from '../types';

type Props = {
	loading?: boolean;
	className?: string;
	shapeColorClassName?: string;
	shapeSize?: SkeletonShapeProps['size'];
	children?: React.ReactNode;
};

function flattenChildren(nodes: React.ReactNode): React.ReactNode[] {
	return React.Children.toArray(nodes).flatMap((node) => {
		if (React.isValidElement(node) && node.type === React.Fragment) {
			return flattenChildren((node.props as { children?: React.ReactNode }).children);
		}
		return [node];
	});
}

export function SkeletonContainer(props: Props) {
	const { className = '', loading = false, shapeColorClassName = '', shapeSize = 'medium', children } = props;
	const flatChildren = flattenChildren(children);
	return (
		<div className={className}>
			{flatChildren.map((child) => {
				if (React.isValidElement<SkeletonShapeProps>(child)) {
					const { loading: childLoading, className: childClassName, size: childSize } = child.props;
					const mergedClassName = `${shapeColorClassName} ${childClassName || ''}`.trim();
					return React.cloneElement(child, {
						loading: childLoading ?? loading,
						className: mergedClassName,
						size: childSize || shapeSize,
					});
				}
				return child;
			})}
		</div>
	);
}
